import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '340+',
  label: 'Channels Scaled'
}, {
  value: '€2.8M',
  label: 'Revenue Generated'
}, {
  value: '4.7x',
  label: 'Avg. Rate Increase'
}, {
  value: '89%',
  label: 'Client Retention'
}];
export function Results() {
  return <section className="py-12 relative z-10 bg-stream-600/10 border-y border-stream-500/20" data-id="element-138">
      <div className="max-w-7xl mx-auto px-6" data-id="element-139">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 divide-x-0 md:divide-x divide-white/10" data-id="element-140">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="text-center px-4" data-id="element-141">
              <div className="font-mono text-4xl md:text-5xl font-bold text-white mb-2 drop-shadow-[0_0_15px_rgba(168,85,247,0.3)]" data-id="element-142">
                {stat.value}
              </div>
              <div className="text-sm text-stream-300 font-medium uppercase tracking-wider" data-id="element-143">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}